import * as JSON_Pointer from "json-pointer";
import * as JSON_Query from "json-query";


export class JP {
  public static get(object:Object, pointer:string):any{
    let result = void 0;
    if (JP.has(object, pointer)){
      result = JSON_Pointer.get(object, pointer);
    }
    return result;
  }

  public static has(object:Object, pointer:string):boolean{
    return JSON_Pointer.has(object, pointer);
  }

  public static set(object:Object, pointer:string, value:any):void{
    JSON_Pointer.set(object, pointer, value);
  }

  public static remove(object:Object, pointer:string):void{
    JSON_Pointer.remove(object, pointer);
  }
}

export function query(object: any, query: string): any {
  return JSON_Query(query, { data: object}).value;
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/helpers/jp.ts